export default {
  EQP_INFO: { // v1.0 Base Info
    TITLE: {
      T0001: 'Fab Info List',
      T0002: 'EQP Info List',
      T0003: 'EQP Copy',
      T0004: 'Event Info List',
      T0005: 'Recipe Info List',
      T0006: 'Step Info List',
      T0007: 'Parameter Info List',
      T0008: 'Parameter List',
      T0009: 'Virtual Parameter',
      T0010: 'Chart',
      T0011: 'Copy Module Match',
      T0012: 'Function List',
      T0013: 'Fab Add',
      T0014: 'Fab Edit',
      T0015: 'Recipe Edit',
      T0016: 'Recipe Add',
      T0017: 'EQP Add',
      T0018: 'EQP Edit',
      T0019: 'Parameter Edit',
      T0020: 'Parameter Add',
      T0021: 'Event Edit',
      T0022: 'Event Add'
    },
    LABEL: {
      ITEMS: 'Items',
      EQP_INFO: 'EQP Info',
      DATA_COLLECTION_PLAN: 'Data Collection Plan',
      CONTEXT: 'Context',
      FAULT_DETECTION_MODEL: 'Fault Detection Model',
      FROM: 'From',
      TO: 'To',
      OPTION: 'Option',
      EQP_ADD: 'Add EQP',
      EQP_ID: 'EQP ID',
      EQP_NAME: 'Alias Name',
      NEW_EQP_ADD: 'Add New EQP',
      PARAMETER_NAME: 'Parameter Name',
      MATCHED_MODULE_ID: 'Matched Module ID',
      VALIDATION: 'Validation',
      SELECT_LOT: 'Select LOT',
      FUNCTION_NAME: 'Function Name',
      FAB: 'Fab',
      LINE: 'Line',
      AREA: 'Area',
      VENDOR: 'Vendor',
      EQP_MODEL: 'Eqp Model',
      USABLE: 'Usable',
      DESCRIPTION: 'Description',
      RECIPE: 'Recipe',
      STEP_COUNT: 'Step Count',
      MAX_PROCESS_TIME: 'Max Process Time',
      STEP: 'Step',
      SETTLING_TIME: 'Settling Time',
      START_SETTLING_TIME: 'Start Settling Time',
      END_SETTLING_TIME: 'End Settling Time',
      ACTIVATION_TIME: 'Activation Time',
      EQP_MAIN: 'EQP Main',
      MODULE: 'Module',
      EQP: 'EQP'
    },
    BUTTON: {
      SELECT_LOT: 'Select LOT'
    },
    MESSAGE: {
      INFORM_NOT_COPY_ITEM: '<br>Unmatched equipment will not be copied.',
      INFORM_EXIST_EQP_INFO: '"To Equipment" has baseline information. If you continue, baseline information may be deleted or modified.<br><br>',
      INFORM_MATCH_EQP: 'If you want to copy from Equipment to Equipment,<br> you should match "From Module" and "To Module".',
      INFORM_NOT_VALID_MATCHED: 'There is not matched equipment.',
      INFORM_NOT_VALID_SELECTED_EQP: 'This Module Id is already selected.',
      INFORM_NOT_VIRTUAL: 'This is not Virtual Parameter.',
      CONFIRM_COPY: 'Equipment will be copied. Are you sure?',
      CONFIRM_VALIDATION: 'Javascript code will be validated. Are you sure?',
      CODE_DESC_001: 'Important',
      CODE_DESC_002: 'Do not change the name of function. (virtual)',
      CODE_DESC_003: 'Use Function as "Brique.(Function Name)"',
      CODE_DESC_004: 'The usage of function argument is as follows.',
      CODE_DESC_005: '1. paramName : paramName.(parameter name)',
      CODE_DESC_006: '2. contextName : contextName.(context name)',
      CODE_DESC_007: '3. step : stepId.(step ID)'
      // CODE_DESC_003: 'You can add Defined function when drag & drop from Parameter List.',
      // CODE_DESC_004: 'The time in Function cannot be modified.'
    },
    COLUMN: {
      FROM_MODULE_ID: 'From Module Id',
      TO_MODULE_ID: 'To Module Id'
    }
  },
  DATA_COLLECTION: { // v1.0 Collection
    TITLE: {
      T0001: 'Data Collection Plan List',
      T0002: 'Event Collection Plan',
      T0003: 'Trace Collection Plan',
      T0004: 'Context Mapping Plan',
      T0005: 'Event CEID Register',
      T0006: 'Context Mapping Plan List',
      T0007: 'Trace Collection Plan List',
      T0008: 'Trace TRID Register',
      T0009: 'Trace Collection Plan Info',
      T0010: 'Vid List',
      T0011: 'Selected Vid List'
    },
    LABEL: {
      EVENT_COLLECTION_PLAN: 'Event Collection Plan',
      TRACE_COLLECTION_PLAN: 'Trace Collection Plan',
      CONTEXT_MAPPING_PLAN: 'Context Mapping Plan',
      TRID: 'TRID',
      TRID_MAIN: 'TRID Main',
      RUN_INTERVAL: 'Run Interval',
      IDLE_INTERVAL: 'Idle Interval'
    },
    MESSAGE: {
      FAILED_UNSAVED_EXEC: 'There is unsaved data. <br>Please save and try again.',
      NOT_MULTI_USABLE: 'Not Multi Usable Fields',
      INFORM_NOT_CHECK_VID: 'Please select all the same VID.'
    }
  },
  REAL_TIME: { // v1.0 Monitor
    TITLE: {
      T0001: 'EQP Status Monitor',
      T0002: 'Parameter List',
      T0003: 'Real Time View',
      T0004: 'Event',
      T0005: 'Fault'
    },
    LABEL: {
      RUN: 'RUN',
      IDLE: 'IDLE',
      DOWN: 'DOWN',
      UNKNOWN: 'UNKNOWN'
    }
  },
  DATA_PREPROCESS: {
    TITLE: {
      T0001: 'Preprocessing Param List',
      T0002: 'Plan Info'
    },
    LABEL: {
      REMOVAL_VALUE: 'Removal Value',
      DATA_CORRECTION: 'Data Correction',
      MEAN: 'Mean',
      REGRESSION: 'Regression',
      REFERENCE_SIZE: 'Reference Size',
      NORMALIZATION: 'Normalization',
      STDEV: 'Stdev'
    }
  },
  AUTO_MODEL: {
    TITLE: {
      T0001: 'Auto Model Plan List',
      T0002: 'Auto Model Plan Info'
    },
    LABEL: {
      USABLE: 'Usable',
      PARAMETER_NAME: 'Parameter Name',
      CHANGE_TYPE: 'Change Type',
      REFERENCE_SIZE: 'Reference Size',
      AUTO_SAVE: 'Auto Save',
      AUTO_RUN: 'Auto Run',
      AUTO_UPDATE: 'Auto Update'
    },
    MESSAGE: {
      INFORM_NO_DATA_ADDED: 'There is no added data in the table.',
      INFORM_DATA_WORKING: 'There is a row workint on it.'
    }
  },
  FAULT_DETECTION: { // v1.0 Model
    TITLE: {
      T0001: 'SetPoint Model',
      T0002: 'Formula Model',
      T0003: 'Multivariate Model',
      T0004: 'Select LOT',
      T0005: 'Model Condition',
      T0006: 'Model List'
    },
    LABEL: {
      LAST_TOP: 'Last Top',
      LOTS: 'LOTs',
      DAY: 'Day',
      WEEK: 'Week',
      MONTH: 'Month',
      DIRECT_SELECTION: 'Direct Selection',
      SELECT_LOT_FILTER: 'Select LOT Filter',
      FAULT: 'Fault',
      ALARM: 'Alarm',
      INTERLOCK: 'Interlock',
      SEARCHED_LOT: 'Searched LOT',
      SELECTED_LOT: 'Selected LOT',
      MEAN: 'Mean',
      STDEV: 'Stdev',
      SIGMA: 'Sigma',
      USL_OFFSET: 'USL Offset',
      UCL_OFFSET: 'UCL Offset',
      LCL_OFFSET: 'LCL Offset',
      LSL_OFFSET: 'LSL Offset',
      FEATURES: 'Feature Selection',
      PCA: 'PCA',
      HOTELINGT2: 'Hoteling T2',
      CUTOFF: 'Importance Cutoff',
      CUMULATIVE_PER: 'Cumulative Percent',
      SETTLING_TIME: 'Settling Time',
      ACTIVATION_TIME: 'Activation Time',
      VARIABLE_IMPORTANCE_CHART: 'Variable Importance Chart',
      PCA_CUMULATIVE_CHART: 'PCA Cumulative Chart',
      LOADING_CHART: 'Loading Chart',
      SCORE_CHART: 'Score Chart',
      MAX_VARIABLE_COUNT: 'Max Variable Count',
      SELECTED_COUNT: 'Selected Count',
      PARAMETER_NAME: 'Parameter Name',
      RECIPE: 'Recipe',
      STEP: 'Step',
      MODEL_ALIAS: 'Model Alias'
    },
    BUTTON: {
      NEXT_STEP: 'Next Step',
      AUTO_SPEC: 'Auto Spec',
      SELECT_LOTS: 'Select LOT',
      AUTO_FORMULA: 'Auto Formula'
    },
    COLUMN: {
      STEP_LIST: 'Step List'
    },
    MESSAGE: {
      INFORM_NOT_RUN_PCA: 'Please run the PCA.',
      CONFIRM_CONDITION_SAVE: '<br/>Existing data may be deleted.',
      INFORM_NOT_SELECT_THREE_FEATURE: 'Please select 3 or more Feature.'
    }
  },
  STATS_ANALYSIS: {
    TITLE: {
      T0001: 'EQP Compare Chart',
      T0002: 'MVA Analysis'
    },
    LABEL: {
      FEATURES: 'Feature Selection',
      PCA: 'PCA',
      HOTELINGT2: 'Hoteling T2',
      CUTOFF: 'Importance Cutoff',
      CUMULATIVE_PER: 'Cumulative Percent',
      VARIABLE_IMPORTANCE_CHART: 'Variable Importance Chart',
      PCA_CUMULATIVE_CHART: 'PCA Cumulative Chart',
      LOADING_CHART: 'Loading Chart',
      SCORE_CHART: 'Score Chart',
      MAX_VARIABLE_COUNT: 'Max Variable Count',
      SELECTED_COUNT: 'Selected Count',
      SELECTED_PARAMETER: 'Selected Parameter',
      SELECTED_STEP: 'Selected Step',
      SELECTED_SUMMARY_TYPE: 'Selected Summary'
    },
    BUTTON: {
      LOTS: 'Select LOT',
      NEXT_STEP: 'Next Step'
    },
    MESSAGE: {
      INFORM_NOT_RUN_PCA: 'Please run the PCA.',
      INFORM_NOT_SELECT_THREE_FEATURE: 'Please select 3 or more Feature.'
    }
  },
  FAULT_CLASS: {
    TITLE: {
      T0001: 'Model List',
      T0002: 'Fault Class List',
      T0003: 'Fault Analysis Chart',
      T0004: 'MVA Fault List',
      T0005: 'Fault Class Register'
    },
    LABEL: {
      FAULT_STATE: 'Fault State',
      FAULT_CAUSE: 'Fault Cause',
      FAULT_ACTION: 'Fault Action'
    }
  },
  FAULT_ACTION: {
    TITLE: {
      T0001: 'Model List',
      T0002: 'Fault Action',
      T0003: 'Email Sending User List',
      T0004: 'User Info List'
    },
    LABEL: {
      MES_INTERLOCK: 'MES Interlock',
      EMAIL_SEND: 'Email Send',
      FAULT_LEVEL: 'Fault Level',
      CONDITION: 'Condition',
      USER_ID: 'User Id',
      USER_NAME: 'User Name'
    },
    COLUMN: {
      DEPT_NAME: 'Dept Name'
    }
  },
  ANALYSIS_REPORT: {
    TITLE: {
      T0001: 'Area Analysis',
      T0002: 'EQP Analysis',
      T0003: 'EQP Model Analysis',
      T0004: 'FD Model Analysis',
      T0005: 'EQP Alarm List',
      T0006: 'Fault Action History'
    }
  },
  CHANGE_DETECTION: {
    TITLE: {
      T0001: 'Change Detection Plan List',
      T0002: 'Change Detection Plan Info'
    },
    LABEL: {
      USABLE: 'Usable',
      AUTO_SAVE: 'Auto Save',
      CHANGE_TYPE: 'Change Type',
      DETECTION_TYPE: 'Detection Type',
      PARAMETER_NAME: 'Parameter Name',
      DETECTION_PERIOD: 'Detection Period'
    },
    MESSAGE: {
      INFORM_NO_DATA_ADDED: 'There is no added data in the table.',
      INFORM_DATA_WORKING: 'There is a row workint on it.'
    }
  },
  DATA_STORAGE: {
    TITLE: {
      T0001: 'EQP History',
      T0002: 'Lot History',
      T0003: 'Lot List',
      T0004: 'Parameter List',
      T0005: 'Parameter Analysis'
    },
    MESSAGE: {
      TOO_MANY_RESULTS: 'Too Many Results.'
    }
  },
  SUMMARY_DATA: {
    TITLE: {
      T0001: 'Data Summary Plan',
      T0002: 'Parameter List',
      T0003: 'Recipe List',
      T0004: 'Step List',
      T0005: 'Summary Type',
      T0006: 'Summary Analysis',
      T0007: 'Trend Analysis'
    },
    LABEL: {
      PLAN_START: 'Plan Start',
      PLAN_COMMIT: 'Plan Commit',
      LOT_STEP: 'Lot-Step'
    }
  },
  FAULT_CLASSIFICATION: {
    TITLE: {
      T0001: 'Model List',
      T0002: 'Fault Class List',
      T0003: 'Fault Analysis Chart',
      T0004: 'MVA Fault List',
      T0005: 'Fault Class Register'
    },
    LABEL: {
      FAULT_CLASS: 'Fault Class',
      FAULT_STATE: 'Fault State',
      FAULT_CAUSE: 'Fault Cause',
      FAULT_ACTION: 'Fault Action'
    }
  },
  MANAGEMENT: { // v1.0 Admin
    TITLE: {
      T0001: 'Code Type List',
      T0002: 'Code List',
      T0003: 'Use Info Manager',
      T0004: 'Fab Use Info Manager',
      T0005: 'EQP Use Info Manager',
      T0006: 'Recipe Use Info Manager',
      T0007: 'Parameter Use Info Manager',
      T0008: 'Event Use Info Manager',
      T0009: 'Step Use Info Manager',
      T0010: 'Virtual EAP List',
      T0011: 'Host List',
      T0012: 'EQP List',
      T0013: 'EQP Alarm Manager'
    },
    COLUMN: {
      CODE_TYPE: 'Code Type',
      CODE: 'Code',
      NAME_ENG: 'Eng Name',
      PARAM_START: 'Param Start',
      PARAM_END: 'Param End',
      DATA_COUNT: 'Data Count',
      INTERVAL: 'Interval (ms)',
      WAFER_IDLE_TIME: 'Wafer Idle Time (s)',
      LOT_IDLE_TIME: 'Lot Idle Time (s)',
      WAFER_COUNT: 'Wafer Count',
      STEP_COUNT: 'Step Count',
      HOST_NAME: 'Host Name',
      HOST_TYPE: 'Host Type',
      IP_ADDR: 'IP Addr.',
      STATUS: 'Status'
    },
    MESSAGE: {
      CONFIRM_DOWN_LEVEL_DELETE: 'Sub-items are also deleted.<br/>',
      START: 'start',
      STOP: 'stop',
      VIRTUAL_EAP_CONFIRM_PREFIX: 'Do you want to ',
      VIRTUAL_EAP_CONFIRM_POSTFIX: ' Virtual EAP?',
      MISSING_REQUIRED_ITEMS: 'Please check the required items.'
    }
  },
  SPC: {
    TITLE: {
      SPCMODEL: 'SPC Model List',
      SPCRULE: 'SPC Rules',
      SPCANALYSISCHART: 'SPC Analysis Chart',
      SPCANALYSISGRID: 'SPC Fault List'
    },
    LABEL: {
      CHART: 'Chart',
      HISTOGRAM: 'Histogram',
      RAWDATA: 'Raw Data',
      STEP: 'Step',
      LOTSTEP: 'Lot Step',
      OUTLIER: 'Outlier',
      SELECT: 'Select',
      LOT_STEP: 'Lot-Step',
      SPC_MODEL_LIST: 'SPC Model List',
      PARAM_ALIAS: 'Param Alias',
      SUMMARY_TYPE: 'Summary Type',
      TOTAL_SAMPLE_COUNT: 'Sample Count',
      SAMPLE_MEAN: 'Sample Mean',
      SAMPLE_STDEV: 'Sample Stdev',
      WEIGHT: 'Weight',
      SIGMA_ESTIMATE: 'Sigma Estimate',
      USL: 'USL',
      UCL: 'UCL',
      CL: 'CL',
      LCL: 'LCL',
      LSL: 'LSL',
      UPPER_OUTLIER: 'Upper Outlier',
      LOWER_OUTLIER: 'Lower Outlier',
      RECIPE: 'Recipe',
      STEP_ID: 'Step Id',
      EQP_ID: 'Eqp Id',
      MODULE_ID: 'Module Id',
      RULE_NO: 'Rule No',
      RELATED_VALUE: 'Related Value',
      SHOW_SIGMA: 'Show Sigma'
    },
    COLUMN: {
      FAB: 'Fab',
      EQP_ID: 'Eqp Id',
      MODULE_ID: 'Module Id',
      PARAM_NAME: 'Param Name',
      PARAM_ALIAS: 'Param Alias',
      RECIPE_ID: 'Recipe Id',
      STEP_ID: 'Step Id',
      SMRY_TYPE: 'Summary Type',
      END_DT: 'DateTime',
      VALUE: 'Value',
      LOT_STEP_YN: 'Lot Step',
      USE_YN: 'SPC Use',
      TARGET_MEAN_VAL: 'MIN',
      TARGET_STD_VAL: 'STD',
      LCL_VAL: 'LCL',
      UCL_VAL: 'UCL',
      LSL_VAL: 'LSL',
      USL_VAL: 'USL',
      PARAM_ALIAS2: 'Param Alias',
      FAULT_RULE_NO: 'Fault Rule No.',
      CL_VAL: 'CL',
      SIGMA_ESTIMATE: 'Sigma Estimate',
      RULE_USE_YN: 'Rule Use',
      RULE_NO: 'Rule No',
      RULE_DESC: 'Description',
      RULE_FIGURES: 'Description Figures',
      FAULT_LEVEL: 'Fault Level',
      EMAIL_YN: 'Email',
      EMAIL_GROUP_ID: 'Email Group Id',
      INTERLOCK_YN: 'Interlock',
      CREATE_USER: 'Create User',
      DATE_TIME: 'Date Time',
      M1SIGMA: 'M1 Sigma',
      M2SIGMA: 'M2 Sigma',
      P1SIGMA: 'P1 Sigma',
      P2SIGMA: 'P2 Sigma',
      FAULT_RULE_LIST: 'Fault Rule List'
    },
    BUTTON: {
      SELECTLOT: 'Select LOT',
      AUTOSPEC: 'Auto Spec',
      REMOVESAMPLES: 'Remove Samples',
      REMOVEOUTLIER: 'Remove Outlier',
      SIMULATION: 'Simulation',
      SAVE: 'Save',
      ANALYSIS: 'Analysis'
    },
    MESSAGE: {
      RULE_SAVE_VALIDATION: '선택한 Rule이 없으면 SPC 사용여부도 \'사용안함\'이 됩니다. 저장하시겠습니까?',
      UNUSED_SPC_RULE_SAVED: 'Unused SPC Rule Deleted',
      SPC_RULE_SAVED: 'SPC Rule Saved',
      OUTLIER_REMOVED: 'Remove Outlier Completed',
      LOT_LIST_NOTFOUND: 'Lot 정보가 없습니다.',
      SPC_RULE_UNUSED_SAVE: 'SPC Rules are saved unused'
    }
  },
  // FDC_DATA_COLLECTION: {
  //   DATA_COLLECTION_PLAN: {
  //     TITLE_001: 'Data Collection Plan List',
  //     TITLE_002: 'Event Collection Plan',
  //     TITLE_003: 'Trace Collection Plan',
  //     TITLE_004: 'Context Mapping Plan'
  //   },
  //   EVENT_COLLECTION_PLAN: {
  //     TITLE_001: 'Data Collection Plan List',
  //     TITLE_002: 'Event CEID Register'
  //   },
  //   TRACE_COLLECTION_PLAN: {
  //     TITLE_001: 'Data Collection Plan List',
  //     TITLE_002: 'Trace Collection Plan List',
  //     TITLE_003: 'Trace TRID Register'
  //   },
  //   CONTEXT_MAPPING_PLAN: {
  //     TITLE_001: 'Data Collection Plan List',
  //     TITLE_002: 'Context Mapping'
  //   },
  //   BUTTONS: {
  //     REFRESH: 'Refresh',
  //     ADD: 'Add',
  //     SAVE: 'Save',
  //     DELETE: 'Delete',
  //     SEARCH: 'Search',
  //     EDIT: 'Edit',
  //     NEW: 'New',
  //     VALIDATION: 'Validation',
  //     START: 'Start',
  //     STOP: 'Stop'
  //   },
  //   DIALOG: {
  //     SEARCH: {
  //       EQP_NON_SELECTED: 'Equipment is not selected',
  //       SELECT_VALID_CHECK: 'Please select {0}'
  //     },
  //     VALIDATION: {
  //       NON_SELECTED: '{0} is not selected.',
  //       NON_ENTERED: 'Please enter {0}',
  //       NOT_VALID: '{0} is not valid',
  //       KEY: 'Key Duplicated',
  //       NOT_EXIST: 'Not exist Items',
  //       NOT_CHANGED: 'Not changed Items',
  //       NOT_ALLOW_VALUE: 'Not Allow Value',
  //       NOT_MULTI_USABLE: 'Not Multi Usable Fields',
  //       UNSAVED_EXEC: 'Unsaved Data Collection Plan exists. <br>Please Save and try again.'
  //     },
  //     CONFIRM: {
  //       CONFIRM: 'Confirm',
  //       CANCLE: 'Cancle',
  //       SAVE: 'item will be saved. Are you sure?',
  //       MULTI_SAVE: 'items will be saved. Are you sure?',
  //       MULTI_DELETE: 'items will be deleted. Are you sure?',
  //       CHANGES_UNCHECKED: 'Some items have been changed but not checked<br>Changes to items that are not checked will be lost<br><br>',
  //       VALIDATION: 'Javascript code will be validated. Are you sure?',
  //       MULTI_EXEC: 'items will be exec?. Are you sure?'
  //     },
  //     ALERT: {
  //       SUCCESS_SAVE: 'Success to Save',
  //       FAIL_SAVE: 'Fail to Save',
  //       SUCCESS_DELETE: 'Success to Delete',
  //       FAIL_DELETE: 'Fail to Delete',
  //       SUCCESS_COPY: 'Success to Copy',
  //       FAIL_COPY: 'Fail to Copy',
  //       NOT_EXIST: '{0} does not exist',
  //       SUCCESS_EXEC: 'Success to Exec Request',
  //       FAIL_EXEC: 'Fail to Exec Request'
  //     }
  //   }
  // },
  // FDC_REAL_TIME: {
  //   EQP_STATE_MONITOR: {
  //     TITLE_001: 'EQP List',
  //     TITLE_002: 'EQP STATE Monitor',
  //     LABELS: {
  //       RUN: 'RUN',
  //       IDLE: 'IDLE',
  //       DOWN: 'DOWN',
  //       NONE: 'NONE'
  //     },
  //     BUTTONS: {
  //       REFRESH: 'REFRESH'
  //     }
  //   },
  //   REAL_TIME_MONITOR: {
  //     TITLE_001: 'EQP List',
  //     TITLE_002: 'Parameter List',
  //     TITLE_003: 'Real Time View',
  //     TITLE_004: 'Event',
  //     TITLE_005: 'Fault',
  //     BUTTONS: {
  //       START: 'Start',
  //       STOP: 'Stop'
  //     },
  //     ALERTS: {
  //       START: 'Please select parameter in your list.'
  //     }
  //   }
  // },
  // FDC_PREPROCESSING: {
  //   TITLE_001: 'EQP List',
  //   TITLE_002: 'Preprocessing Param List',
  //   TITLE_003: 'Plan Info',
  //   BUTTONS: {
  //     RESET: 'Reset',
  //     SAVE: 'Save',
  //     DELETE: 'Delete',
  //     REFRESH: 'Refresh'
  //   },
  //   ALERTS: {
  //     SAVE_SUCCESS: 'Saved successfully',
  //     SAVE_FAIL: 'Plan info was not saved successfully',
  //     DELETE_SUCCESS: 'Deleted successfully',
  //     DELETE_FAIL: 'Plan info was not deleted successfully',
  //     CONDITION: 'There is no selected plan info',
  //     CONDITION2: 'There is no plan info',
  //     TREE_CONDITION: 'There is no selected Module ID',
  //     MESSAGE: 'Are you sure you want to reset?</br>(Data collected for that parameter can be changed)'
  //   },
  //   DIALOGS: {
  //     CONFIRM: 'Ok',
  //     CANCEL: 'Cancel'
  //   }
  // },
  // FDC_AUTO_MODEL_PLAN: {
  //   TITLE_001: 'EQP List',
  //   TITLE_002: 'Auto Model Plan List',
  //   TITLE_003: 'Auto Model Plan Info',
  //   BUTTONS: {
  //     ADD: 'Add',
  //     SAVE: 'Save',
  //     DELETE: 'Delete'
  //   },
  //   ALERTS: {
  //     SAVE_SUCCESS: 'Saved successfully',
  //     SAVE_CONDITION: 'Please input all information',
  //     SAVE_CHECKBOX_CONDITION: 'There is no added data in the table',
  //     SAVE_FAIL: 'Plan info was not saved successfully',
  //     SAVE_FAIL_DUPLICATED: 'Plan info was not saved successfully <br> Please check if there is a duplicated key',
  //     UPDATE_SUCCESS: 'Updated successfully',
  //     UPDATE_FAIL: 'Plan info was not updated successfully',
  //     UPDATE_FAIL_DUPLICATED: 'Plan info was not updated successfully <br> Please check if there is a duplicated key',
  //     DELETE_SUCCESS: 'Deleted successfully',
  //     DELETE_FAIL: 'Plan info was not deleted successfully',
  //     CONDITION: 'There is no selected plan info',
  //     CONDITION2: 'There is no plan info',
  //     TREE_CONDITION: 'There is no selected Module ID',
  //     WORKING: 'There`s a row working on it',
  //     MESSAGE: 'Are you sure you want to delete this?'
  //   },
  //   DIALOGS: {
  //     CONFIRM: 'Ok',
  //     CANCEL: 'Cancel'
  //   }
  // },
  // FDC_EQP_HISTORY: {
  //   LABEL_001: 'Start',
  //   LABEL_002: 'Stop'
  // },
  // FDC_DETECTION: {
  //   LABEL_001: 'Start',
  //   LABEL_002: 'Stop',
  //   VALIDATION: {
  //     NON_SELECTED: 'Please select {0}',
  //     NON_ENTERED: 'Please enter {0}',
  //     NO_DATA_SELECTED: 'Item is not selected',
  //     NO_DATA_CHANGED: 'Item is not changed',
  //     NOT_EXIST: 'Not exist {0}',
  //     NON_STEP01: 'Select a Feature Selection value',
  //     NON_STEP02: 'Please run the PCA.',
  //     NON_STEP03: 'Please run the Hoteling T2.',
  //     DUP_DATA: 'Duplicate data exists.',
  //     NO_DATA_FOUND: '{0} Data not found.'
  //   },
  //   DIALOG: {
  //     CONFIRM: 'Confirm',
  //     CANCEL: 'Cancel',
  //     CHANGES_UNCHECKED: 'Some items have been changed but not checked<br>Changes to items that are not checked will be lost<br><br>',
  //     SAVE: 'Items will be saved. Are you sure?',
  //     DELETE: 'Items will be deleted. Are you sure?'
  //   },
  //   ALERT: {
  //     SUCCESS_SAVE: 'Success to Save',
  //     SUCCESS_UPDATE: 'Success to Update',
  //     SUCCESS_DELETE: 'Success to Delete',
  //     FAIL_SAVE: 'Fail to Save',
  //     DATA_NOT_FOUND: 'No data was found.'
  //   }
  // },
  // FDC_ANALYSIS: {
  //   VALIDATION: {
  //     NON_STEP01: 'Select a Feature Selection value',
  //     NON_STEP02: 'Please run the PCA.',
  //     NON_SELECTED: 'Please select {0}'
  //   },
  //   ALERT: {
  //     DATA_NOT_FOUND: 'No data was found.'
  //   }
  // },
  // FDC_FAULT_CLASSIFICATION: {
  //   FAULT_CLASSIFICATION: {
  //     TITLE_001: 'Model List',
  //     TITLE_002: 'Fault Class List',
  //     TITLE_003: 'Fault Analysis Chart'
  //   },
  //   FAULT_CLASS_REGISTER: {
  //     TITLE_001: 'MVA Fault List',
  //     TITLE_002: 'Fault Class Register'
  //   },
  //   BUTTONS: {
  //     REFRESH: 'Refresh',
  //     ADD: 'Add',
  //     SAVE: 'Save',
  //     DELETE: 'Delete',
  //     SEARCH: 'Search',
  //     EDIT: 'Edit',
  //     NEW: 'New',
  //     VALIDATION: 'Validation',
  //     START: 'Start',
  //     STOP: 'Stop'
  //   },
  //   DIALOG: {
  //     SEARCH: {
  //       EQP_NON_SELECTED: 'Equipment is not selected',
  //       SELECT_VALID_CHECK: 'Please select {0}'
  //     },
  //     VALIDATION: {
  //       NON_SELECTED: '{0} is not selected.',
  //       NON_ENTERED: 'Please enter {0}',
  //       NOT_VALID: '{0} is not valid',
  //       KEY: 'Key Duplicated',
  //       NOT_EXIST: 'Not exist Items',
  //       NOT_CHANGED: 'Not changed Items',
  //       NOT_ALLOW_VALUE: 'Not Allow Value',
  //       NOT_MULTI_USABLE: 'Not Multi Usable Fields',
  //       UNSAVED_EXEC: 'Unsaved Data Collection Plan exists. <br>Please Save and try again.'
  //     },
  //     CONFIRM: {
  //       CONFIRM: 'Confirm',
  //       CANCLE: 'Cancle',
  //       SAVE: 'item will be saved. Are you sure?',
  //       MULTI_SAVE: 'items will be saved. Are you sure?',
  //       MULTI_DELETE: 'items will be deleted. Are you sure?',
  //       CHANGES_UNCHECKED: 'Some items have been changed but not checked<br>Changes to items that are not checked will be lost<br><br>',
  //       VALIDATION: 'Javascript code will be validated. Are you sure?',
  //       MULTI_EXEC: 'items will be exec?. Are you sure?'
  //     },
  //     ALERT: {
  //       SUCCESS_SAVE: 'Success to Save',
  //       FAIL_SAVE: 'Fail to Save',
  //       SUCCESS_DELETE: 'Success to Delete',
  //       FAIL_DELETE: 'Fail to Delete',
  //       SUCCESS_COPY: 'Success to Copy',
  //       FAIL_COPY: 'Fail to Copy',
  //       NOT_EXIST: '{0} does not exist',
  //       SUCCESS_EXEC: 'Success to Exec Request',
  //       FAIL_EXEC: 'Fail to Exec Request'
  //     }
  //   }
  // },
  // FDC_FAULT_ACTION_PLAN: {
  //   TITLE_001: 'Search Condition',
  //   TITLE_002: 'Model List',
  //   TITLE_003: 'Fault Action',
  //   TITLE_004: 'Email Sending User List',
  //   TITLE_005: 'User Info List',
  //   BUTTONS: {
  //     REFRESH: 'Refresh',
  //     ADD: 'Add',
  //     SAVE: 'Save',
  //     DELETE: 'Delete',
  //     SEARCH: 'Search',
  //     CLEAR: 'Clear',
  //     APPLY: 'Apply',
  //     CLOSE: 'Close'
  //   },
  //   LABEL: {
  //     INTERLOCK: 'MES Interlock',
  //     EMAIL: 'Email Send',
  //     CONDITION: 'Condition',
  //     USER_ID: 'User Id',
  //     USER_NAME: 'User Name'
  //   },
  //   DIALOG: {
  //     SEARCH: {
  //       EQP_NON_SELECTED: 'Equipment is not selected',
  //       SELECT_VALID_CHECK: 'Please select {0}'
  //     },
  //     VALIDATION: {
  //       NON_SELECTED: '{0} is not selected.',
  //       NON_ENTERED: 'Please enter {0}',
  //       NOT_VALID: '{0} is not valid',
  //       KEY: 'Key Duplicated'
  //     },
  //     CONFIRM: {
  //       CONFIRM: 'Confirm',
  //       CANCEL: 'Cancel',
  //       SAVE: 'Item will be saved. Are you sure?',
  //       MULTI_SAVE: 'items will be saved. Are you sure?',
  //       DELETE: 'Item will be deleted. Are you sure?',
  //       MULTI_DELETE: 'items will be deleted. Are you sure?',
  //       CHANGES_UNCHECKED: 'Some items have been changed but not checked<br>Changes to items that are not checked will be lost<br><br>',
  //       VALIDATION: 'Javascript code will be validated. Are you sure?'
  //     },
  //     ALERT: {
  //       SUCCESS_SAVE: 'Success to Save',
  //       FAIL_SAVE: 'Fail to Save',
  //       SUCCESS_DELETE: 'Success to Delete',
  //       FAIL_DELETE: 'Fail to Delete',
  //       SUCCESS_COPY: 'Success to Copy',
  //       FAIL_COPY: 'Fail to Copy',
  //       NOT_EXIST: '{0} does not exist'
  //     }
  //   }
  // },
  // FDC_REPORT: {
  //   FAULT_ANALYSIS_REPORT: {
  //     TITLE_001: 'Area Analysis',
  //     TITLE_002: 'EQP Model Analysis',
  //     TITLE_003: 'EQP Analysis',
  //     TITLE_004: 'FD Model Analysis'
  //   },
  //   ALARM_ANALYSIS_REPORT: {
  //     TITLE_001: 'EQP Alarm List',
  //     TITLE_002: 'Fault Class Register'
  //   },
  //   FAULT_ACTION_HISTORY: {
  //     TITLE_001: 'Fault Action History'
  //   },
  //   BUTTONS: {
  //     REFRESH: 'Refresh',
  //     ADD: 'Add',
  //     SAVE: 'Save',
  //     DELETE: 'Delete',
  //     SEARCH: 'Search',
  //     EDIT: 'Edit',
  //     NEW: 'New',
  //     VALIDATION: 'Validation',
  //     START: 'Start',
  //     STOP: 'Stop',
  //     EXPORT: 'Export'
  //   },
  //   LABEL: {
  //     PERIOD: 'Period'
  //   },
  //   DIALOG: {
  //     SEARCH: {
  //       EQP_NON_SELECTED: 'Equipment is not selected',
  //       SELECT_VALID_CHECK: 'Please select {0}'
  //     },
  //     VALIDATION: {
  //       NON_SELECTED: '{0} is not selected.',
  //       NON_ENTERED: 'Please enter {0}',
  //       NOT_VALID: '{0} is not valid',
  //       KEY: 'Key Duplicated',
  //       NOT_EXIST: 'Not exist Items',
  //       NOT_CHANGED: 'Not changed Items',
  //       NOT_ALLOW_VALUE: 'Not Allow Value',
  //       NOT_MULTI_USABLE: 'Not Multi Usable Fields',
  //       UNSAVED_EXEC: 'Unsaved Data Collection Plan exists. <br>Please Save and try again.'
  //     },
  //     CONFIRM: {
  //       CONFIRM: 'Confirm',
  //       CANCLE: 'Cancle',
  //       SAVE: 'item will be saved. Are you sure?',
  //       MULTI_SAVE: 'items will be saved. Are you sure?',
  //       MULTI_DELETE: 'items will be deleted. Are you sure?'
  //     },
  //     ALERT: {
  //       SUCCESS_SAVE: 'Success to Save',
  //       FAIL_SAVE: 'Fail to Save',
  //       SUCCESS_DELETE: 'Success to Delete',
  //       FAIL_DELETE: 'Fail to Delete'
  //     }
  //   }
  // },
  // FDC_DETECTION_CDP: {
  //   TITLE_001: 'EQP List',
  //   TITLE_002: 'Change Detection Plan List',
  //   TITLE_003: 'Change Detection Plan Info',
  //   BUTTONS: {
  //     SEARCH: 'Search',
  //     RESET: 'Reset',
  //     SAVE: 'Save',
  //     DELETE: 'Delete',
  //     REFRESH: 'Refresh'
  //   },
  //   ALERTS: {
  //     SAVE_SUCCESS: 'Saved successfully',
  //     SAVE_CONDITION: 'Please input all information',
  //     SAVE_CHECKBOX_CONDITION: 'There is no added data in the table',
  //     SAVE_FAIL: 'Plan info was not saved successfully',
  //     SAVE_FAIL_DUPLICATED: 'Plan info was not saved successfully <br> Please check if there is a duplicated key',
  //     UPDATE_SUCCESS: 'Updated successfully',
  //     UPDATE_FAIL: 'Plan info was not updated successfully',
  //     UPDATE_FAIL_DUPLICATED: 'Plan info was not updated successfully <br> Please check if there is a duplicated key',
  //     DELETE_SUCCESS: 'Deleted successfully',
  //     DELETE_FAIL: 'Plan info was not deleted successfully',
  //     CONDITION: 'There is no selected plan info',
  //     CONDITION2: 'There is no plan info',
  //     TREE_CONDITION: 'There is no selected Module ID',
  //     WORKING: 'There`s a row working on it',
  //     MESSAGE: 'Are you sure you want to delete this?'
  //   },
  //   DIALOGS: {
  //     CONFIRM: 'Ok',
  //     CANCEL: 'Cancel'
  //   }
  // },

  // FDC_DATA_STORAGE: {
  //   EQP_HISTORY: {
  //     TITLE_001: 'Search Condition',
  //     TITLE_002: 'EQP History',
  //     LABEL_001: 'Period',
  //     BUTTONS: {
  //       SEARCH: 'Search',
  //       EXPORT: 'Export'
  //     },
  //     DIALOG: {
  //       SEARCH: {
  //         MODULEID_NON_SELECTED: 'There is no module selected.',
  //         PERIOD_NON_SELECTED: 'Please select a search period.',
  //         NO_DATA_FOUNDED: 'No data was found.'
  //       }
  //     }
  //   },
  //   LOT_HISTORY: {
  //     TITLE_001: 'Search Condition',
  //     TITLE_002: 'Lot History',
  //     LABEL_001: 'Period',
  //     BUTTONS: {
  //       SEARCH: 'Search',
  //       EXPORT: 'Export'
  //     },
  //     DIALOG: {
  //       SEARCH: {
  //         MODULEID_NON_SELECTED: 'There is no module selected.',
  //         PERIOD_NON_SELECTED: 'Please select a search period.',
  //         NO_DATA_FOUNDED: 'No data was found.'
  //       }
  //     }
  //   },
  //   PARAMETER_ANALYSIS: {
  //     TITLE_001: 'Search Condition',
  //     TITLE_002: 'Parameter List',
  //     TITLE_003: 'Parameter Analysis',
  //     LABEL_001: 'From',
  //     LABEL_002: 'To',
  //     BUTTONS: {
  //       SEARCH: 'Search',
  //       EXPORT: 'Export'
  //     },
  //     DIALOG: {
  //       SEARCH: {
  //         PARAMID_NON_SELECTED: 'There is no parameter selected.',
  //         PERIOD_NON_SELECTED: 'Please select a search period.',
  //         NO_DATA_FOUNDED: 'No data was found.'
  //       }
  //     }
  //   }
  // },
  CHART_COMPONENT: {
    TITLE: {
      T0001: '차트 옵션 선택',
      T0002: '차트 Type 선택',
      T0003: 'Color 선택',
      T0004: 'Chart Data Export',
      T0005: 'Marker 선택'
    },
    LABEL: {
      PALETTE: {
        NAME: 'Palette',
        GGPLOT2: 'ggplot2',
        SEABORN: 'seaborn',
        SIMPLE_WHITE: 'simple_white',
        PLOTLY: 'plotly',
        PLOTLY_DARK: 'plotly_dark',
        PLOTLY_WHITE: 'plotly_white',
        PRESENTATION: 'presentation',
        XGRIDOFF: 'xgridoff',
        YGRIDOFF: 'ygridoff',
        GRIDON: 'gridon',
        DEFAULT: 'default'
      },
      SPLIT: 'Split',
      SPLIT_CHART: '스플릿 차트',
      DEFAULT_X_DATA: 'Default X축 데이터',
      INDEX: 'Index',
      SELECT_PALETTE: '팔레트를 선택하세요.',
      CHART: '차트',
      SELECT_X_DATA: 'X축 데이터 선택',
      SELECT_Y_PRIMARY_SECONDARY: 'Y축 Primary / Secondary 선택',
      PRIMARY: 'Primary',
      SECONDARY: 'Secondary',
      CHART_TYPE: {
        LINE: 'Line',
        SCATTER: 'Scatter',
        BAR: 'Bar',
        VERTICAL_BAR: 'Vertical Bar',
        AREA: 'Area',
        PIE: 'Pie',
        HISTOGRAM: 'histogram',
        HISTOGRAM_2D: '2D Histogram',
        CONTOUR_HISTOGRAM_2D: '2D Contour Histogram'
      },
      SIMPLE: 'Simple',
      DISTRIBUTIONS: 'Distributions',
      DATA_LIMIT: 'Data Limit',
      ALL_SHOW: '전체 보기',
      NONE: 'None',
      SIZE: 'Size',
      SYMBOL: 'Symbol',
      X_AXIS: 'X축',
      Y_AXIS: 'Y축',
      Y_AXIS_PRIMARY: 'Y축의 Primary로 표시',
      Y_AXIS_SECONDARY: 'Y축의 Secondary로 표시',
      CONNECTOR_SHOW: '연결선 표시',
      CONNECTOR_HIDE: '연결선 표시 해제',
      MARKER_SELECT: 'Marker 선택',
      COLOR_SELECT: 'Color 선택',
      CHART_TYPE_CHANGE: 'Chart Type 변경',
      DEFAULT_CHART_TITLE: 'Chart Title',
      MODEBAR: {
        TOOLTIP_MOUSEOVER: 'Tooltip Mode - On mouse over',
        TOOLTIP_CLICK: 'Tooltip Mode - Click',
        TOOLTIP_NONE: 'Tooltip Mode - None',
        COPY_TOOLTIP: 'Copy tooltip to clipboard',
        LEGEND_POSITION: 'Legend Position',
        SAMPLING_DATA: '모든 데이터가 표시되고 있습니다. 데이터를 Sampling 하시려면 클릭하세요.',
        RANGE_VIEW: 'Range View',
        PALETTE: '팔레트 선택',
        COPY_IMAGE: 'Copy image to clipboard',
        DATA_GRID: 'Chart Data Grid',
        EXPORT_CSV: 'Export CSV',
        SPLIT_CHART: 'Chart Split',
        X_AXIS: 'X축 데이터 선택',
        Y_AXIS: 'Y축 Primary / Secondary 선택',
        NORMALIZATION: '데이터 정규화',
        HELP: 'Help'
      }
    },
    BUTTON: {
      ADD_CHART: '차트 추가',
      REMOVE_CHART: '차트 제거',
      RESTORE_DEFAULT_COLOR: 'Restore Default Color'
    },
    MESSAGE: {
      INFORM_CHANGE_PALETTE: 'Palette를 변경하였습니다.',
      INFORM_MAKE_SPLIT_CHART: '스플릿 차트를 생성하였습니다.',
      INFORM_CHANGE_X_AXIS_DATA: 'X축 데이터를 변경했습니다.',
      INFORM_TRY_AGAIN_COPY_TOOLTIP: 'Tooltip Mode를 "Click"으로 설정하시고, 데이터 영역에서 클릭하여 툴팁이 보이게 한 후 다시 시도하세요.',
      INFORM_LEGEND_BOTTOM: '범례를 아래에 위치하였습니다.',
      INFORM_LEGEND_TOP: '범례를 위에 위치하였습니다.',
      INFORM_LEGEND_LEFT: '범례를 왼쪽에 위치하였습니다.',
      INFORM_LEGEND_RIGHT: '범례를 오른쪽에 위치하였습니다.',
      INFORM_LEGEND_NONE: '범례를 표시하지 않았습니다.',
      INFORM_SHOW_SAMPLING: 'Sampling 데이터를 표시하였습니다.',
      INFORM_SHOW_SAMPLING_DATA: 'Sampling 데이터를 표시하였습니다. 모든 데이터를 표시하시려면 클릭하세요.',
      INFORM_SHOW_ALL: '모든 데이터를 표시하였습니다.',
      INFORM_SHOW_ALL_DATA: '모든 데이터를 표시하였습니다. 데이터를 Sampling 하시려면 클릭하세요.',
      INFORM_SHOW_RANGE_VIEW: 'Range View를 보이게 하였습니다.',
      INFORM_HIDE_RANGE_VIEW: 'Range View를 보이게 하였습니다.',
      INFORM_NORMALIZATION_DATA: '데이터를 정규화하였습니다.',
      INFORM_NORMALIZATION_DATA_CANCEL: '데이터를 정규화하였습니다.',
      INFORM_TOOLTIP_MOUSEOVER: '차트의 Point에 마우스 오버하면 툴팁이 표시됩니다.',
      INFORM_TOOLTIP_CLICK: '차트의 Point를 클락하면 툴팁이 표시됩니다.',
      INFORM_TOOLTIP_NONE: '차트에 툴팁이 표시되지 않습니다.',
      SUCCEED_COPY_CHART_IMAGE: '차트를 이미지화하여 클립보드에 복사하였습니다. 붙여넣기 하여 사용하시기 바랍니다.',
      SUCCEED_COPY_TOOLTIP: 'Tooltip을 클립보드에 복사하였습니다. 붙여넣기 하여 사용하시기 바랍니다.',
      FAILED_COPY_CHART_IMAGE: '차트 이미지 클립보드 복사가 실패하였습니다.',
      FAILED_COPY_TOOLTIP: 'Tooltip 복사가 실패하였습니다.'
    }
  },
  GRID_COMPONENT: {
    LABEL: {
      INSERTED: 'Inserted',
      MODIFIED: 'Modified',
      REMOVED: 'Removed',
      SELECTED: 'Selected',
      TOTAL: 'Total',
      SHOW_ITEMS_WHERE_THE_VALUE: 'Show items where the Value',
      CONTAINS: 'Contains',
      NOT_CONTAINS: 'Not contains',
      EQUALS: 'Equals',
      NOT_EQUAL: 'Not equal',
      BEGINS_WITH: 'Begins with',
      ENDS_WITH: 'Ends with',
      LESS_THAN: 'Less than',
      LESS_THAN_OR_EQUALS: 'Less than or equals',
      GREATER_THAN: 'Greater than',
      GREATER_THAN_OR_EQUALS: 'Greater than or equals',
      AND: 'And',
      OR: 'Or',
      SELECT_ALL: 'Select All'
    },
    BUTTON: {
      RESTORE: 'Restore',
      TOGGLE_COLUMN: 'Toggle Column',
      ADD_ROW: 'Add Row',
      REMOVE_ROW: 'Remove Row',
      UNDO: 'Undo',
      REDO: 'Redo',
      TOGGLE_SELECTED_ROWS: 'Toggle Selected Rows',
      TOGGLE_MODIFIED_ROWS: 'Toggle Modified Rows',
      ASCENDING: 'Ascending',
      DESCENDING: 'Descending',
      FILTER_BY_COND: 'Filter by Condition',
      FILTER_BY_VAL: 'Filter by Value'
    }
  },
  COMMON: {
    TITLE: {
      T0001: 'Search Condition',
      T0002: 'EQP Tree',
      T0003: 'Trend Analysis Chart'
    },
    LABEL: {
      END: 'End',
      EVENT: 'Event',
      FROM: 'From',
      PARAMETER: 'Parameter',
      STEP: 'Step',
      SUMMARY: 'Summary',
      PERIOD: 'Period',
      RECIPE: 'Recipe',
      START: 'Start',
      STOP: 'Stop',
      TO: 'To',
      TRACE: 'Trace',
      UVA: 'UVA',
      SETPOINT: 'Set-Point',
      FORMULA: 'Formula',
      MVA: 'MVA',
      MODULE: 'Module',
      ALL: 'All',
      USL: 'USL',
      UCL: 'UCL',
      LCL: 'LCL',
      LSL: 'LSL',
      LOT: 'Lot',
      SUBSTRATE: 'Substrate',
      DATE: 'Date',
      INDEX: 'Index',
      TIME: 'Time',
      LOT_ID: 'LOT ID',
      ALARM_LIST: 'Alarm List'
    },
    BUTTON: {
      ADD: 'Add',
      APPLY: 'Apply',
      CLEAR: 'Clear',
      CLOSE: 'Close',
      COPY: 'Copy',
      DELETE: 'Delete',
      EDIT: 'Edit',
      EXPORT: 'Export',
      IMPORT: 'Import',
      NEW: 'New',
      REFRESH: 'Refresh',
      RESET: 'Reset',
      SAVE: 'Save',
      SEARCH: 'Search',
      START: 'Start',
      STOP: 'Stop',
      VALIDATION: 'Validation',
      RUN: 'Run',
      NEXT: 'Next',
      PREVIOUS: 'Previous',
      CONFIRM: 'Confirm',
      CANCEL: 'Cancel',
      ALL: 'All',
      EVENT: 'Event',
      TRACE: 'Trace',
      LOT: 'Lot',
      SUBSTRATE: 'Substrate',
      TIME: 'Time',
      ANALYSIS: 'Analysis'
    },
    MESSAGE: {
      // 사용자 INFORM 관련 메시지
      INFORM_NOT_VALID_FILE_EXTENSION: 'The file extensiont is only {0}',
      INFORM_NOT_VALID_COLUMN: 'Column does not match.<br>Please check column.',
      INFORM_KEY_DUPLICATED: '{0} value is duplicated.',
      INFORM_NO_DATA_FOUND: 'No data was found.',
      INFORM_NO_DATA_CHANGED: 'No data has been changed.',
      INFORM_NO_DATA_SELECTED: 'There is no data selected.',
      INFORM_ITEM_NOT_SELECTED: '{0} is not selected.',
      INFORM_ITEM_NOT_ENTERED: 'Please enter {0}.',
      INFORM_ITEM_NOT_VALID: '{0} is not valid.',
      INFORM_ITEM_NOT_CHANGED: '{0} has not been changed.',
      INFORM_ITEM_NOT_EXIST: '{0} does not exist.',
      INFORM_ITEM_NOT_MOVE: '{0} can\'t move.',
      // 처리 완료 관련 메시지
      SUCCEED_RESET: 'It has been initialized.',
      SUCCEED_SAVE: 'Saved successfully.',
      SUCCEED_UPDATE: 'Modification succeeded.',
      SUCCEED_DELETE: 'Deletion succeeded.',
      SUCCEED_COPY: 'Copy succeeded.',
      SUCCEED_SAVE_ITEM: '{0} has been saved.',
      SUCCEED_UPDATE_ITEM: '{0} has been modified.',
      SUCCEED_DELETE_ITEM: '{0} has been deleted.',
      SUCCEED_COPY_ITEM: '{0} has been copied.',
      SUCCEED_EXEC_REQ: 'The execution request was successful.',
      FAILED_SAVE: 'Failed to save.',
      FAILED_SAVE_BY_DUPLICATED: 'Failed to save.<br>Please check for duplicate data.',
      FAILED_UPDATE: 'Modification failed.',
      FAILED_UPDATE_BY_DUPLICATED: 'Modification failed.<br>Please check for duplicate data.',
      FAILED_DELETE: 'Deletion failed.',
      FAILED_DELETE_BY_EQP: 'Deletion failed because fab has its own eqp',
      FAILED_COPY: 'Copy failed.',
      FAILED_SAVE_ITEM: 'Failed to save {0}.',
      FAILED_UPDATE_ITEM: 'Failed to modify {0}.',
      FAILED_DELETE_ITEM: 'Failed to delete {0}.',
      FAILED_COPY_ITEM: 'Failed to copy {0}.',
      FAILED_EXEC_REQ: 'The request to execute failed.',
      // CONFIRM 관련 메시지
      CONFIRM_RESET: 'Do you want to reset?<br> (All the collected data of the parameter can be changed.)',
      CONFIRM_SAVE: 'Are you sure you want to save?',
      CONFIRM_MULTI_SAVE: 'Do you want to save the row?',
      CONFIRM_DELETE: 'Are you sure you want to delete?',
      CONFIRM_MULTI_DELETE: 'Are you sure you want to delete the row?',
      CONFIRM_UNCHECKED_CHANGED_DATA: 'Some items have been changed but not checked<br>Changes to items that are not checked will be lost<br><br>',
      CONFIRM_MULTI_EXEC: 'items will be exec? Are you sure?',
      // 임시 메시지
      INFORM_UNDER_DEVELOPMENT: '개발 중인 메뉴입니다.'
      // INFORM_UNDER_DEVELOPMENT: 'This Menu is under development.'
    },
    ERROR: {

    },
    COLUMN: {
      FAB: 'Fab',
      LINE: 'Line',
      AREA: 'Area',
      VENDOR: 'Vendor',
      EQP_MODEL: 'EQP Model',
      EQP_ID: 'EQP',
      MODEL_ID: 'Model ID',
      EQP_MAIN: 'EQP Main',
      EQP_NAME: 'Alias Name',
      USABLE: 'Usable',
      MODIFY_TIME: 'Modify Time',
      MODIFY_USER: 'Modify User',
      CEID: 'CEID',
      EVENT_TYPE: 'Event Type',
      DESCRIPTION: 'Description',
      START_EVENT: 'Start Event',
      VIRTUAL: 'Virtual',
      RECIPE: 'Recipe',
      STEP_COUNT: 'Step Count',
      MAX_PROCESS_TIME: 'Max Process Time',
      STEP: 'Step',
      SETTLING_TIME: 'Settling Time',
      START_SETTLING_TIME: 'Start Settling Time',
      END_SETTLING_TIME: 'End Settling Time',
      ACTIVATION_TIME: 'Activation Time',
      VID: 'Vid',
      VID_TYPE: 'Vid Type',
      PARAM_VAL_TYPE: 'Param Value Type',
      PARAM_NAME: 'Parameter Name',
      PARAM_LEVEL: 'Parameter Level',
      PARAM_DESC: 'Parameter Desc',
      ALIAS_NAME: 'Alias Name',
      UNIT: 'Unit',
      NUMBER_TYPE: 'Number Type',
      VIRTUAL_DATA: 'Virtual Data',
      LIST_TYPE: 'List Type',
      LIST_POSITION: 'List Position',
      LIST_DELIMITER: 'List Delimiter',
      OFFSET_TYPE: 'Offset Type',
      OFFSET_VALUE: 'Offset Value',
      PLAN_NAME: 'Plan Name',
      IDLE_APPLY: 'Idle Apply',
      LOT_TIMEOUT: 'Lot Timeout',
      TARGET: 'Target',
      SOURCE: 'Source',
      TARGET_URL: 'Target Url',
      EVENT_CMD: 'Event CMD',
      TRACE_CMD: 'Trace CMD',
      REQUEST_URL: 'Request Url',
      REPLY_URL: 'Reply Url',
      VID_LIST: 'Vid List',
      TRID: 'TRID',
      TRID_MAIN: 'TRID Main',
      GROUP_SIZE: 'Group Size',
      RUN_INTERVAL: 'Run Interval',
      IDLE_INTERVAL: 'Idle Interval',
      CONTEXT_NAME: 'Context Name',
      CONTEXT_TYPE: 'Context Type',
      CONTEXT_KEY: 'Context Key',
      CONTEXT_INDEX: 'Context Index',
      CONTEXT_DATA: 'Context Data',
      SUBST_TIMEOUT: 'Subst Timeout',
      TRACE_TIMEOUT: 'Trace Timeout',
      EVENT_NAME: 'Event Name',
      EVENT_DESC: 'Event Desc',
      MODULE_ID: 'Module',
      NUMBER_YN: 'Number YN',
      VIRTUAL_YN: 'Virtual YN',
      NAME: 'Name',
      TYPE: 'Type',
      LOT_STEP_YN: 'Lot/Step YN',
      MIN: 'MIN',
      MAX: 'MAX',
      MEAN: 'MEAN',
      MEDIAN: 'MEDIAN',
      RANGE: 'RANGE',
      STDEV: 'STDEV',
      SLOPE: 'SLOPE',
      P05: 'P05',
      P10: 'P10',
      P25: 'P25',
      P75: 'P75',
      P90: 'P90',
      P95: 'P95',
      STATUS: 'Status',
      LOT_ID: 'Lot ID',
      CARRIER_ID: 'Carrier',
      BATCH_ID: 'Batch',
      OPER_ID: 'Oper',
      PROD_ID: 'Prod',
      RETICLE_ID: 'Reticle',
      LOT_TYPE: 'Lot Type',
      PPID: 'PPID',
      DEVICE: 'Device',
      LAYER: 'Layer',
      ETC_INFO: 'Etc Info',
      DATE_TIME: 'Date Time',
      EVENT: 'Event',
      SUBST_ID: 'Subst ID',
      SLOT: 'Slot',
      PRODUCT: 'Product',
      OPERATION: 'Operation',
      PROCESS: 'Process',
      MODEL: 'Model',
      RESULT: 'Result',
      SPEC: 'Spec',
      ALARM: 'Alarm',
      START_DATE: 'Start Date',
      END_DATE: 'End Date',
      SUMMARY_TYPE: 'Summary Type',
      INDEX: 'Index',
      USL: 'USL',
      UCL: 'UCL',
      LCL: 'LCL',
      LSL: 'LSL',
      SEQ: 'Seq',
      MODEL_NAME: 'Model Name',
      MODEL_TYPE: 'Model Type',
      MODEL_ALIAS: 'Model Alias',
      ACTIVE: 'Active',
      SEQ_OPERATION: 'Seq Operation',
      FAULT_LEVEL: 'Fault Level',
      EMAIL: 'Email',
      INTER_LOCK: 'Inter Lock',
      PART: 'Part',
      USER_ID: 'User ID',
      USER_NAME: 'User Name',
      CHANGE_TYPE: 'Change Type',
      DETECTION_TYPE: 'Detection Type',
      PERIOD: 'Period',
      AUTO_SAVE: 'Auto Save',
      AUTO_RUN: 'Auto Run',
      AUTO_UPDATE: 'Auto Update',
      REFERENCE_SIZE: 'Reference Size',
      PLAN_DATA: 'Plan Data',
      MVA_TYPE: 'MVA Type',
      FAULT_CLASS: 'Fault Class',
      FAULT_STATE: 'Fault State',
      FAULT_CAUSE: 'Fault Cause',
      FAULT_ACTION: 'Fault Action',
      FAULT: 'Fault',
      WARNING: 'Warning',
      ALARM_ID: 'Alarm ID',
      ALARM_CODE: 'Alarm Code',
      ALARM_SEVERITY: 'Severity',
      ALARM_TEXT: 'Alarm Text',
      ALARM_DATE: 'Alarm Date',
      ALARM_DESC: 'Alarm Description',
      CREATE_DATE: 'Create Date',
      ACTION_TYPE: 'Action Type',
      ALARM_MESSAGE: 'Alarm Message',
      REPLY_MESSAGE: 'Reply Message',
      VARIABLE: 'Variable',
      CONTEXT_OPERATION: 'Context Operation',
      LOGIC_OPERATION: 'Logic Operation',
      TEMP_COUNT: 'Temp Count',
      DISPLAY_ORDER: 'Display Order',
      ALARM_TIME: 'Alarm Time',
      RULE_NO: 'Rule No',
      RULE_USE_YN: 'Rule Use',
      SUBSTRATE_ID: 'Substrate Id',
      RECIPE_ID: 'Recipe Id',
      STEP_ID: 'Step Id',
      ALARM_VALUE: 'Alarm Value',
      RULE_DESC: 'Rule Description',
      MONITOR: 'Monitor'
    }
  }
}
